<ng-container *ngIf="simulationStatus$ | async; let simulationStatus">
  <div class="basin-p-x-1 basin-pt-1">


    <div class="basin-display-flex basin-flex-column">
      <app-detail-field label="Previous Loop Time" [value]="formatTime(simulationStatus.timeSinceLastIterationLog)" *ngIf="simulationLoopService.isLooping()"></app-detail-field>
      <app-detail-field label="Average Loop Time" [value]="formatTime(simulationStatus.averageTimePerIterationLog)"></app-detail-field>
      <app-detail-field label="Landslides" [value]="simulationStatus.landslideCount | number"></app-detail-field>
      <app-detail-field label="Initiation Points" [value]="simulationStatus.startingAgents | number"></app-detail-field>
      <app-detail-field label="Loops" [value]="simulationStatus.iterations | number"></app-detail-field>
    </div>

    <div
      class="basin-display-flex basin-flex-column basin-mt-2"
      *ngIf="debuggerAccess$ | async"
    >
      <app-detail-field label="Average Complexity Rating" [value]="simulationStatus.averageComplexityRatings | number"></app-detail-field>
    </div>

    <ng-container *ngIf="simulationDetailsEnabled$ | async">
      <p-divider></p-divider>
      <div class="basin-display-flex basin-flex-column">
        <app-detail-field label="Average Agents" [value]="simulationStatus.averageStepsPerIteration | number"></app-detail-field>
        <app-detail-field label="Max Agents" [value]="simulationStatus.maxStepsPerIteration | number"></app-detail-field>
        <app-detail-field label="Min Agents" [value]="simulationStatus.minStepsPerIteration | number"></app-detail-field>
        <app-detail-field label="Average Cells" [value]="simulationStatus.averageUniqueStepsPerIteration | number"></app-detail-field>
        <app-detail-field label="Max Cells" [value]="simulationStatus.maxUniqueStepsPerIteration | number"></app-detail-field>
        <app-detail-field label="Min Cells" [value]="simulationStatus.minUniqueStepsPerIteration | number"></app-detail-field>
      </div>
    </ng-container>
  </div>
</ng-container>
